import {
  LOADER_SET,
  NOTIFY_SET,
  RESET_REDUX,
  USER_SET,
  MENU_SET,
  SELECT_CASE_DATE_SET,
  ONLINE_SET,
  SERVER_URL_SET,
  PRODUCTS_SET,
  SCANNER_SET,
  GO_BACK_SET,
  OTHER_CHARGE_SET,
  CASE_FILTER_SET,
  TEAM_SET,
  PREFERENCE_SET,
  MISSING_DGRS_FILTER_SET,
  MISSING_POS_FILTER_SET,
  NOT_BILLED_FILTER_SET,
  BILLED_FILTER_SET,
  TABLE_NAME_SET,
  SELECTED_EXPRESS_SETS_SET,
  LOT_SCANNER_SET,
  SETS_SEARCH_SET,
  SETS_LIST_STATE_STORAGE,
  PREFERENCE_OPTIONS,
  SEARCH_BILLED_DATA_SET,
  OFFICE_SETS_FILTER_SET,
  EXPRESS_CARE_SETS_FILTER_SET,
  SETS_FILTER_SET,
  NOT_BILLING_FILTER_SET,
  SEARCH_BILLED_CASE_COUNT_DATA_SET,
  CALENDAR_FILTER_SET,
  SELECTED_SETS_PAYLOAD_SET,
  SEARCH_FILTER_SET,
  SCAN_INVENTORY_SET,
  SINGLE_SCAN_SESSION_SET,
  INVENTORY_FILTER_SET,
  FIRST_LOGIN_SESSION_TOKEN_SET,
  SCAN_INVENTORY_SCANNER_SET,
  VHN_PPC_OTHER_CHARGE_SET,
  UPDATED_ROUTE_SET,
  DERS_DETAILS_SET,
  CASE_DER_SET,
  DER_FILTER_SET,
  DER_SEARCH_FILTER_SET,
  DERS_PRODUCTS_SET,
  VIEW_DERS_DETAILS_SET,
  DERS_FILTER_RESULT_SET,
  IS_SHOW_BUTTONS_SET,
  SELECT_CASE_ID_SET,
  AGGREGATE_PLAN_SET,
  NOTIFICATIONS_SET,
  PREV_ROUTE_SET,
  SALES_FILTER_SET,
  SETS_TO_MOVE_SET,
  DER_MODAL_SET,
  SALES_YTD_SET,
  READ_ONLY_PRODUCT_NOTES_SET,
  READ_CASE_DATA_SET,
  AUTO_LOGIN_DATA_SET,
  SURGEONNOTE_SET,
  SAVED_SCROLL_POSTION_SET,
  THEME_COLOR_SET,
  THEME_DETECT_COLOR_SET,
  THEME_COLOR_NUMBER_SET,
  CALENDAR_MONTH_END_DATE_SET,
  BROWSER_DETECT_SET,
} from './actions';

export const DEFAULT_USER = {
  id: null,
  userName: '',
  office: null,
  team: null,
  token: '',
};

export const DEFAULT_IS_SHOW_BUTTON = {
  isCreate: false,
  isView: false,
  isCopy: false,
  isEdit: false,
  isSaved: false,
  isSubmitted: false
};

export const loader = (state = false, action) => {
  switch (action.type) {
    case LOADER_SET:
      return action.data;

    default:
      return state;
  }
};

export const notify = (state = {}, action) => {
  switch (action.type) {
    case NOTIFY_SET:
      return action.state;

    default:
      return state;
  }
};

export const user = (state = null, action) => {
  switch (action.type) {
    case USER_SET:
      return action.user;
    case RESET_REDUX: {
      const remember = state.hasOwnProperty('remember') ? state.remember : {};
      const userData = DEFAULT_USER;
      userData.remember = remember;
      return userData;
    }

    default:
      return state;
  }
};

export const menu = (state = [], action) => {
  switch (action.type) {
    case MENU_SET:
      return action.data;
    case RESET_REDUX:
      return [];

    default:
      return state;
  }
};

export const selectCaseDate = (state = '', action) => {
  switch (action.type) {
    case SELECT_CASE_DATE_SET:
      return action.data;
    case RESET_REDUX:
      return '';
    default:
      return state;
  }
};

export const online = (state = false, action) => {
  switch (action.type) {
    case ONLINE_SET:
      return action.data;

    default:
      return state;
  }
};

export const serverUrl = (state = {}, action) => {
  switch (action.type) {
    case SERVER_URL_SET:
      return action.data;
    case RESET_REDUX:
      return {};
    default:
      return state;
  }
};

export const products = (state = [], action) => {
  switch (action.type) {
    case PRODUCTS_SET:
      return action.data;
    case RESET_REDUX:
      return [];
    default:
      return state;
  }
};

export const scanner = (state = {}, action) => {
  switch (action.type) {
    case SCANNER_SET:
      return action.data;
    case RESET_REDUX:
      return {};
    default:
      return state;
  }
};

export const goBack = (state = [], action) => {
  switch (action.type) {
    case GO_BACK_SET: {
      const uniqueData = action.data.filter((item, pos) => action.data[pos - 1] !== item);
      return uniqueData;
    }
    case RESET_REDUX:
      return [];
    default:
      return state;
  }
};

export const otherCharge = (state = {}, action) => {
  switch (action.type) {
    case OTHER_CHARGE_SET:
      return action.data;
    case RESET_REDUX:
      return {};
    default:
      return state;
  }
};

export const caseFilter = (state = {}, action) => {
  switch (action.type) {
    case CASE_FILTER_SET:
      return action.data;
    case RESET_REDUX:
      return {};
    default:
      return state;
  }
};

export const team = (state = {}, action) => {
  switch (action.type) {
    case TEAM_SET:
      return action.data;
    case RESET_REDUX:
      return {};
    default:
      return state;
  }
};

export const preference = (state = [], action) => {
  switch (action.type) {
    case PREFERENCE_SET:
      return action.data;
    case RESET_REDUX:
      return [];
    default:
      return state;
  }
};

export const missingDgrsFilter = (state = {}, action) => {
  switch (action.type) {
    case MISSING_DGRS_FILTER_SET:
      return action.data;
    case RESET_REDUX:
      return {};
    default:
      return state;
  }
};

export const missingPosFilter = (state = {}, action) => {
  switch (action.type) {
    case MISSING_POS_FILTER_SET:
      return action.data;
    case RESET_REDUX:
      return {};
    default:
      return state;
  }
};

export const notBilledFilter = (state = {}, action) => {
  switch (action.type) {
    case NOT_BILLED_FILTER_SET:
      return action.data;
    case RESET_REDUX:
      return {};
    default:
      return state;
  }
};

export const billedFilter = (state = {}, action) => {
  switch (action.type) {
    case BILLED_FILTER_SET:
      return action.data;
    case RESET_REDUX:
      return {};
    default:
      return state;
  }
};

export const tableName = (state = '', action) => {
  switch (action.type) {
    case TABLE_NAME_SET:
      return action.data;
    case RESET_REDUX:
      return '';
    default:
      return state;
  }
};

export const selectedExpressSets = (state = [], action) => {
  switch (action.type) {
    case SELECTED_EXPRESS_SETS_SET:
      return action.data;
    case RESET_REDUX:
      return [];
    default:
      return state;
  }
};

export const lotScanner = (state = {}, action) => {
  switch (action.type) {
    case LOT_SCANNER_SET:
      return action.data;
    case RESET_REDUX:
      return {};
    default:
      return state;
  }
};

export const setsSearch = (state = {}, action) => {
  switch (action.type) {
    case SETS_SEARCH_SET:
      return action.data;
    case RESET_REDUX:
      return {};
    default:
      return state;
  }
};

export const setsListStateStorage = (state = {}, action) => {
  switch (action.type) {
    case SETS_LIST_STATE_STORAGE:
      return action.data;
    case RESET_REDUX:
      return {};
    default:
      return state;
  }
};

export const preferenceOptions = (state = {}, action) => {
  switch (action.type) {
    case PREFERENCE_OPTIONS:
      return action.data;
    case RESET_REDUX:
      return {};
    default:
      return state;
  }
};

export const searchBilledData = (state = [], action) => {
  switch (action.type) {
    case SEARCH_BILLED_DATA_SET:
      return action.data;
    case RESET_REDUX:
      return [];
    default:
      return state;
  }
};

export const officeSetsFilter = (state = [], action) => {
  switch (action.type) {
    case OFFICE_SETS_FILTER_SET:
      return action.data;
    case RESET_REDUX:
      return [];
    default:
      return state;
  }
};

export const expressCareSetsFilter = (state = [], action) => {
  switch (action.type) {
    case EXPRESS_CARE_SETS_FILTER_SET:
      return action.data;
    case RESET_REDUX:
      return [];
    default:
      return state;
  }
};

export const setsFilter = (state = {}, action) => {
  switch (action.type) {
    case SETS_FILTER_SET:
      return action.data;
    case RESET_REDUX:
      return {};
    default:
      return state;
  }
};

export const notBillingFilter = (state = {}, action) => {
  switch (action.type) {
    case NOT_BILLING_FILTER_SET:
      return action.data;
    case RESET_REDUX:
      return {};
    default:
      return state;
  }
};

export const searchBilledCaseCountData = (state = {}, action) => {
  switch (action.type) {
    case SEARCH_BILLED_CASE_COUNT_DATA_SET:
      return action.data;
    case RESET_REDUX:
      return {};
    default:
      return state;
  }
};

export const calendarFilter = (state = {}, action) => {
  switch (action.type) {
    case CALENDAR_FILTER_SET:
      return action.data;
    case RESET_REDUX:
      return {};
    default:
      return state;
  }
};

export const selectedSetsPayload = (state = [], action) => {
  switch (action.type) {
    case SELECTED_SETS_PAYLOAD_SET:
      return action.data;
    case RESET_REDUX:
      return [];
    default:
      return state;
  }
};

export const searchFilter = (state = {}, action) => {
  switch (action.type) {
    case SEARCH_FILTER_SET:
      return action.data;
    case RESET_REDUX:
      return {};
    default:
      return state;
  }
};

export const scanInventory = (state = {}, action) => {
  switch (action.type) {
    case SCAN_INVENTORY_SET:
      return action.data;
    case RESET_REDUX:
      return {};
    default:
      return state;
  }
};

export const singleScanSession = (state = {}, action) => {
  switch (action.type) {
    case SINGLE_SCAN_SESSION_SET:
      return action.data;
    case RESET_REDUX:
      return {};
    default:
      return state;
  }
};

export const inventoryFilter = (state = {}, action) => {
  switch (action.type) {
    case INVENTORY_FILTER_SET:
      return action.data;
    case RESET_REDUX:
      return {};
    default:
      return state;
  }
};

export const firstLoginSessionToken = (state = '', action) => {
  switch (action.type) {
    case FIRST_LOGIN_SESSION_TOKEN_SET:
      return action.data;
    case RESET_REDUX:
      return '';
    default:
      return state;
  }
};

export const scanInventoryScanner = (state = {}, action) => {
  switch (action.type) {
    case SCAN_INVENTORY_SCANNER_SET:
      return action.data;
    case RESET_REDUX:
      return {};
    default:
      return state;
  }
};

export const vhnPpcOtherCharge = (state = false, action) => {
  switch (action.type) {
    case VHN_PPC_OTHER_CHARGE_SET:
      return action.data;

    default:
      return state;
  }
};

export const updatedRoute = (state = '', action) => {
  switch (action.type) {
    case UPDATED_ROUTE_SET:
      return action.data;
    case RESET_REDUX:
      return '';
    default:
      return state;
  }
};

export const dersDetails = (state = {}, action) => {
  switch (action.type) {
    case DERS_DETAILS_SET:
      return action.data;
    case RESET_REDUX:
      return {};
    default:
      return state;
  }
};

export const caseDer = (state = false, action) => {
  switch (action.type) {
    case CASE_DER_SET:
      return action.data;

    default:
      return state;
  }
};

export const derFilter = (state = {}, action) => {
  switch (action.type) {
    case DER_FILTER_SET:
      return action.data;
    case RESET_REDUX:
      return {};
    default:
      return state;
  }
};

export const derSearchFilter = (state = {}, action) => {
  switch (action.type) {
    case DER_SEARCH_FILTER_SET:
      return action.data;
    case RESET_REDUX:
      return {};
    default:
      return state;
  }
};

export const dersProducts = (state = [], action) => {
  switch (action.type) {
    case DERS_PRODUCTS_SET:
      return action.data;
    case RESET_REDUX:
      return [];
    default:
      return state;
  }
};

export const dersFilterResult = (state = [], action) => {
  switch (action.type) {
    case DERS_FILTER_RESULT_SET:
      return action.data;
    case RESET_REDUX:
      return [];
    default:
      return state;
  }
};

export const viewDersDetails = (state = false, action) => {
  switch (action.type) {
    case VIEW_DERS_DETAILS_SET:
      return action.data;

    default:
      return state;
  }
};

export const selectCaseId = (state = '', action) => {
  switch (action.type) {
    case SELECT_CASE_ID_SET:
      return action.data;
    case RESET_REDUX:
      return '';
    default:
      return state;
  }
};

export const isShowButtons = (state = DEFAULT_IS_SHOW_BUTTON, action) => {
  switch (action.type) {
    case IS_SHOW_BUTTONS_SET:
      return action.state;
    case RESET_REDUX: {
      const showButtonsData = DEFAULT_IS_SHOW_BUTTON;
      return showButtonsData;
    }
    default:
      return state;
  }
};

export const aggregatePlan = (state = [], action) => {
  switch (action.type) {
    case AGGREGATE_PLAN_SET:
      return action.data;
    case RESET_REDUX:
      return [];
    default:
      return state;
  }
};

export const notifications = (state = { unread: 0, data: [] }, action) => {
  switch (action.type) {
    case NOTIFICATIONS_SET:
      return action.data;
    case RESET_REDUX:
      return { unread: 0, data: [] };
    default:
      return state;
  }
};

export const prevRoute = (state = { path: '', newPath: '' }, action) => {
  switch (action.type) {
    case PREV_ROUTE_SET:
      return { path: state.newPath, newPath: action.data };
    case RESET_REDUX:
      return { path: '', newPath: '' };
    default:
      return state;
  }
};

export const salesFilter = (state = {}, action) => {
  switch (action.type) {
    case SALES_FILTER_SET:
      return action.data;
    case RESET_REDUX:
      return {};
    default:
      return state;
  }
};

export const setsToMove = (state = [], action) => {
  switch (action.type) {
    case SETS_TO_MOVE_SET:
      return action.data;
    case RESET_REDUX:
      return [];
    default:
      return state;
  }
};

export const derModal = (state = { show: false }, action) => {
  switch (action.type) {
    case DER_MODAL_SET:
      return action.data;
    case RESET_REDUX:
      return { show: false };
    default:
      return state;
  }
};

export const salesYTD = (state = 0, action) => {
  switch (action.type) {
    case SALES_YTD_SET:
      return action.data;
    case RESET_REDUX:
      return 0;
    default:
      return state;
  }
};

export const readOnlyProductNotes = (state = true, action) => {
  switch (action.type) {
    case READ_ONLY_PRODUCT_NOTES_SET:
      return action.data;
    case RESET_REDUX:
      return true;
    default:
      return state;
  }
};

export const readCaseData = (state = true, action) => {
  switch (action.type) {
    case READ_CASE_DATA_SET:
      return action.data;
    case RESET_REDUX:
      return true;
    default:
      return state;
  }
};

export const autoLoginData = (state = false, action) => {
  switch (action.type) {
    case AUTO_LOGIN_DATA_SET:
      return action.data;
    case RESET_REDUX:
      return false;
    default:
      return state;
  }
};

export const surgeonNote = (state = [], action) => {
  switch (action.type) {
    case SURGEONNOTE_SET:
      return action.data;
    case RESET_REDUX:
      return [];
    default:
      return state;
  }
};

export const savedScrollPosition = (state = 0, action) => {
  switch (action.type) {
    case SAVED_SCROLL_POSTION_SET:
      return action.data;
    case RESET_REDUX:
      return 0;
    default:
      return state;
  }
};

export const themeColor = (state = '', action) => {
  switch (action.type) {
    case THEME_COLOR_SET:
      return action.data;
    case RESET_REDUX:
      return '';
    default:
      return state;
  }
};

export const themeDetectColor = (state = '', action) => {
  switch (action.type) {
    case THEME_DETECT_COLOR_SET:
      return action.data;
    case RESET_REDUX:
      return '';
    default:
      return state;
  }
};

export const themeColorNumber = (state = '', action) => {
  switch (action.type) {
    case THEME_COLOR_NUMBER_SET:
      return action.data;
    case RESET_REDUX:
      return '';
    default:
      return state;
  }
};

export const calendarMonthEndDate = (state = [], action) => {
  switch (action.type) {
    case CALENDAR_MONTH_END_DATE_SET:
      return action.data;
    case RESET_REDUX:
      return [];
    default:
      return state;
  }
};

export const browserDetect = (state = '', action) => {
  switch (action.type) {
    case BROWSER_DETECT_SET:
      return action.data;
    case RESET_REDUX:
      return '';
    default:
      return state;
  }
};
